import { defineMessages } from 'react-intl';

export const metadatas = {
  default: defineMessages({
    title: {
      defaultMessage: 'Best Fantasy NBA – Sorare NBA',
    },
    description: {
      defaultMessage:
        "Collect, play and win officially licensed digital cards featuring the world's best NBA players.",
    },
  }),
  market: defineMessages({
    title: {
      defaultMessage: 'Cards Market – Sorare NBA',
    },
    description: {
      defaultMessage:
        "Discover new Sorare cards featuring the world's best NBA teams and players on Sorare NBA",
    },
  }),
  newSignings: defineMessages({
    title: {
      defaultMessage: 'New Cards Auctions – Sorare NBA',
    },
    description: {
      defaultMessage:
        "Find and collect new Sorare cards featuring the world's best NBA teams and players on Sorare NBA",
    },
  }),
  transfers: defineMessages({
    title: {
      defaultMessage: 'Manager Sales Market – Sorare NBA',
    },
    description: {
      defaultMessage:
        'Find, collect and trade cards with other Sorare Managers',
    },
  }),
  instantBuy: defineMessages({
    title: {
      defaultMessage: 'Instant Buy Market – Sorare NBA',
    },
    description: {
      defaultMessage:
        "Find and collect new Sorare cards featuring the world's best NBA teams and players on Sorare NBA",
    },
  }),
  team: defineMessages({
    title: {
      defaultMessage: '{team} – Team Profile – Sorare NBA',
    },
    description: {
      defaultMessage:
        'Find all the statistics of {team}, collect and trade officially licensed digital cards of your favorite team on Sorare NBA, the #1 Fantasy NBA game',
    },
  }),
};
